{
  "longPressMessage": "Dolg pritisk za odpiranje predogleda"
}
